"use client"

import clsx from "clsx"
import { ReactNode, useState } from "react"
import { Spinner } from "src/components/icons"
import { A } from "src/components/unstyled/A"

export type FilterButtonProps = {
  href: string
  active: boolean
  children: ReactNode
}

export const FilterButton = ({ href, active, children }: FilterButtonProps) => {
  const [clicked, setClicked] = useState(false)
  const Element = active ? "span" : A

  return (
    <Element
      href={href}
      onClick={active ? undefined : () => setClicked(true)}
      className={clsx("flex h-10 min-w-10 items-center justify-center text-lg font-semibold", {
        "text-muted hover:text-subtle": !active,
        "text-default hover:text-subtle": active,
      })}
    >
      {clicked ? <Spinner /> : children}
    </Element>
  )
}
